export default "__VITE_ASSET__b2b1cd54__"